import React from 'react';

import { useContextHandling } from 'common/hooks/useContextHandling';

type ContextValue = {
  isSingleColumnView: boolean;
  setIsSingleColumnView: (value: boolean) => void;
};

export const SingleColumnViewContext = React.createContext<ContextValue | null>(null);

export const SingleColumnViewProvider = ({ children }: React.PropsWithChildren<{}>) => {
  const [isSingleColumnView, setIsSingleColumnView] = React.useState(false);

  return (
    <SingleColumnViewContext.Provider value={{ isSingleColumnView, setIsSingleColumnView }}>
      {children}
    </SingleColumnViewContext.Provider>
  );
};

export const useSingleColumnView = () => useContextHandling(SingleColumnViewContext, fallbackState);

const fallbackState: ContextValue = { isSingleColumnView: false, setIsSingleColumnView: () => {} };
